import { Pagination } from "@material-ui/lab";
import React from "react";
import "./pagination.css";

const CostumePagination = ({ setPage, numPages }) => {


  const handleChange = (event, value) => {
    setPage(value);
    window.scroll(0, 0);
  };

  return (
    <div className="pagenation">
      <Pagination
        count={numPages}
        onChange={handleChange}
      />
    </div>
  );
};

export default CostumePagination;
